import { initializeGoogleMaps } from '../utils/googleMapsLoader.js';
import { importLibrary } from '@googlemaps/js-api-loader';

export default (params = {}) => ({
    comps: params.comps || [],
    property: params.property || null,
    withPolygon: params.withPolygon || false,
    editable: params.editable ?? true,
    initialVertices: params.initialVertices || [],

    async init() {
        if (this.property) {
            initializeGoogleMaps();
            this.initMap();
        }

        this.$watch('editable', () => {
            this.initMap();
        });
    },

    async initMap() {
        const mapContainer = document.getElementById("map");
        mapContainer.innerHTML = "";

        const lat = parseFloat(this.property.latitude);
        const lng = parseFloat(this.property.longitude);

        const {Map, InfoWindow, Polygon, LatLng} = await importLibrary("maps");
        const {AdvancedMarkerElement} = await importLibrary("marker");
        const {ColorScheme} = await importLibrary("core");

        this._LatLng = LatLng;
        const event = google.maps.event;

        const map = new Map(document.getElementById("map"), {
            center: {lat, lng},
            zoom: 15,
            minZoom: 11,
            maxZoom: 16,
            mapId: "4504f8b37365c3d0",
            colorScheme: ColorScheme.DARK,
            disableDefaultUI: true,
            gestureHandling: 'cooperative',
        });

        const infoWindow = new InfoWindow({maxWidth: 420});

        if (this.withPolygon) {
            this.startPolygon(map, lat, lng, { Polygon, event, LatLng }, this.initialVertices);
        }

        const getImg = (c) => c.photo_url || null

        const badge = (c) => c.construction_situation === "renovated" ? `<span class="cc-badge cc-badge--ren">Renovated</span>` : `<span class="cc-badge">Base</span>`;

        const cardStyles = () => `<style>
      /* Override Google Maps InfoWindow chrome */
      .gm-style-iw-c { background:transparent !important; padding:0 !important; border-radius:12px !important; box-shadow:0 4px 24px rgba(0,0,0,.5) !important; overflow:visible !important; }
      .gm-style-iw-d { overflow:auto !important; padding:0 !important; }
      .gm-style-iw-chr { position:absolute !important; top:8px; right:8px; z-index:10; height:auto !important; }
      .gm-style-iw-c button[aria-label="Close"] { background:rgba(0,0,0,.45) !important; border-radius:50% !important; width:28px !important; height:28px !important; display:flex !important; align-items:center !important; justify-content:center !important; }
      .gm-style-iw-c button[aria-label="Close"] span { background-color:#97B0BF !important; margin:0 !important; }
      .gm-style-iw-c button[aria-label="Close"]:hover span { background-color:#E0ECF4 !important; }
      /* Balloon tail / arrow */
      .gm-style-iw-tc { filter:drop-shadow(0 2px 4px rgba(0,0,0,.3)) !important; }
      .gm-style-iw-tc::after { background:rgba(13,31,43,0.92) !important; }
      .gm-style-iw-t::after { background:rgba(13,31,43,0.92) !important; }

      .cc-card {
        width: 380px;
        max-width: 92vw;
        border-radius: 12px;
        overflow: hidden;
        color: #E0ECF4;
        font-family: 'Plus Jakarta Sans', 'Figtree', ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Inter, Arial;
        background: linear-gradient(0deg, rgba(13,31,43,0.85) 0%, rgba(13,31,43,0.85) 100%), rgba(158,219,250,0.08);
        backdrop-filter: blur(12px);
        border: 1px solid rgba(255,255,255,0.10);
      }
      .cc-media {
        height: 170px;
        background: #131D25;
        display: block;
        position: relative;
      }
      .cc-media img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        opacity: 0.9;
      }
      .cc-badge {
        display:inline-block;
        margin-left:8px;
        font-size:10px;
        font-weight:600;
        padding:3px 8px;
        border-radius:999px;
        border:1px solid #3E5665;
        background:transparent;
        color:#97B0BF;
        vertical-align:middle;
      }
      .cc-badge--ren {
        background:#04302E;
        border-color:#6EE9E6;
        color:#6EE9E6;
        text-shadow:0 0 6px rgba(110,233,230,0.4);
      }
      .cc-body { padding: 14px 16px 16px; }
      .cc-title { font-weight:700; font-size:14px; margin:2px 0 8px; color:#C5D7E2; display:flex; align-items:center; }
      .cc-grid {
        display:grid;
        grid-template-columns:1fr auto;
        gap:8px;
        align-items:center;
        padding-right:24px;
      }
      .cc-price { font-size:18px; font-weight:800; color:#23C5F6; display:flex; align-items:center; gap:8px; }
      .cc-chip {
        font-size:10px;
        font-weight:600;
        color:#97B0BF;
        background:rgba(255,255,255,0.06);
        border:1px solid #3E5665;
        border-radius:8px;
        padding:4px 8px;
        margin-right: 20px;
      }
      .cc-chip--subject {
        background:#002032;
        border-color:#23C5F6;
        color:#23C5F6;
        text-shadow:0 0 6px rgba(35,197,246,0.4);
      }
      .cc-feat {
        display:flex;
        gap:12px;
        margin-top:8px;
        font-size:12px;
        color:#7898AB;
      }
      .cc-feat .i { display:inline-flex; align-items:center; gap:6px; }
      .cc-dot {
        width:5px; height:5px; border-radius:50%; background:#23C5F6;
        display:inline-block; vertical-align:middle; margin-right:6px;
        box-shadow:0 0 4px rgba(35,197,246,0.5);
      }
      .cc-details {
        display:flex;
        gap:6px;
        align-items:center;
        margin-top:8px;
        font-size:11px;
        color:#7898AB;
      }
      .cc-details-sep { color:#3E5665; }
      .cc-tags {
        display:flex;
        flex-wrap:wrap;
        gap:6px;
        margin-top:10px;
      }
      .cc-tag {
        display:inline-block;
        font-size:10px;
        font-weight:600;
        padding:2px 8px;
        border-radius:999px;
        border:1px solid #3E5665;
        background:rgba(255,255,255,0.04);
        color:#97B0BF;
        text-transform:capitalize;
        cursor:default;
      }
      .cc-tag--error {
        background:#2B0810;
        border-color:#E26F86;
        color:#E26F86;
        text-shadow:0 0 6px rgba(226,111,134,0.4);
      }
      .cc-tag--secondary {
        background:#04302E;
        border-color:#6EE9E6;
        color:#6EE9E6;
        text-shadow:0 0 6px rgba(110,233,230,0.4);
      }
      .cc-status {
        font-size:10px;
        font-weight:700;
        padding:2px 7px;
        border-radius:999px;
        text-transform:uppercase;
        letter-spacing:0.5px;
      }
      .cc-status--active {
        background:#0F2D08;
        border:1px solid #88E576;
        color:#88E576;
        text-shadow:0 0 6px rgba(136,229,118,0.4);
      }
      .cc-status--inactive {
        background:#2B0810;
        border:1px solid #E26F86;
        color:#E26F86;
        text-shadow:0 0 6px rgba(226,111,134,0.4);
      }
      .cc-links {
        display:flex;
        gap:12px;
        margin-top:10px;
      }
      .cc-link {
        font-size:11px;
        font-weight:600;
        color:#B5ECFC;
        text-decoration:none;
        padding:4px 10px;
        border:1.5px solid #23C5F6;
        border-radius:6px;
        background:transparent;
        transition:all 0.2s;
      }
      .cc-link:hover {
        background:#23C5F6;
        color:#091018;
      }
    </style>`;

        const compCardHTML = (c) => {
            const img = getImg(c);
            const hasImage = !!img;
            const isActive = c.status === 'active';

            const tagBadgeColors = {
                success: { bg: '#0F2D08', border: '#88E576', color: '#88E576' },
                warning: { bg: '#392E00', border: '#FEDA6D', color: '#FEDA6D' },
            };
            const tagColor = tagBadgeColors[c.tag_badge] || tagBadgeColors.warning;

            const reasonTags = (c.reason_labels || []).map(r =>
                `<span class="cc-tag cc-tag--error" title="${r.description}">${r.label}</span>`
            ).join('');

            const showConstructionTag = c.construction_situation && c.construction_situation !== 'undefined';
            const constructionTag = showConstructionTag
                ? `<span class="cc-tag cc-tag--secondary" title="${c.construction_situation_description || ''}">${c.construction_situation_label || c.construction_situation}</span>`
                : '';

            const recencyTag = c.tag
                ? `<span class="cc-tag" style="background:${tagColor.bg};border-color:${tagColor.border};color:${tagColor.color};text-shadow:0 0 6px ${tagColor.color}40;" title="${c.tag_tip || ''}">${c.tag}</span>`
                : '';

            const tagsHTML = (recencyTag || reasonTags || constructionTag)
                ? `<div class="cc-tags">${recencyTag}${constructionTag}${reasonTags}</div>`
                : '';

            const statusBadge = isActive
                ? `<span class="cc-status cc-status--active">Included</span>`
                : `<span class="cc-status cc-status--inactive">Excluded</span>`;

            const detailItems = [
                c.square_footage ? `${Number(c.square_footage).toLocaleString()} sqft` : null,
                c.sold_at ? `Sold At ${c.sold_at}` : null,
                c.sim_score ? `Score ${(Number(c.sim_score) * 100).toFixed(0)}%` : null,
            ].filter(Boolean);

            const detailsRow = detailItems.length
                ? `<div class="cc-details">${detailItems.map(d => `<span>${d}</span>`).join('<span class="cc-details-sep">&middot;</span>')}</div>`
                : '';

            return `
  <div class="cc-card">
    ${cardStyles()}

    ${hasImage ? `
          <div class="cc-media">
            <img src="${img}" alt="Comp photo" referrerpolicy="no-referrer" />
          </div>
        ` : ""}

    <div class="cc-body">
      <div class="cc-grid">
        <div class="cc-price">
          ${formatIntegerToCurrency(c.price)}
          ${statusBadge}
        </div>
        <div class="cc-chip">${c.distance ? `${c.distance} mi` : "-"}</div>
      </div>
      <div class="cc-title">
        <span>${c.address ?? c.title ?? "Comparable"}</span>
        ${badge(c)}
      </div>
      <div class="cc-feat">
        <span class="i"><span class="cc-dot"></span>${c.bedrooms ?? "-"} Bed</span>
        <span class="i"><span class="cc-dot"></span>${c.bathrooms ?? "-"} Bath</span>
      </div>
      ${detailsRow}
      ${tagsHTML}
      ${c.full_address ? `
      <div class="cc-links">
        <a href="https://www.zillow.com/homes/${c.full_address}_rb/" target="_blank" class="cc-link">View on Zillow</a>
      </div>
      ` : ''}
    </div>
  </div>`;
        };

        const subjectCardHTML = () => `
          <div class="cc-card">
            ${cardStyles()}

            <div class="cc-body">
              <div class="cc-grid">
                <div class="cc-price">${formatIntegerToCurrency(this.property.purchase_price)}</div>
                <div class="cc-chip cc-chip--subject">Subject</div>
              </div>
              <div class="cc-title">${this.property.address}</div>
              <div class="cc-feat">
                <span class="i"><span class="cc-dot"></span>${this.property.bedrooms ?? "-"} Bed</span>
                <span class="i"><span class="cc-dot"></span>${this.property.bathrooms ?? "-"} Bath</span>
              </div>
            </div>
          </div>
        `;
        const homeIcon = document.createElement("div");
        homeIcon.innerHTML = `
          <div style="background:rgba(0,0,0,.75);border-radius:50%;padding:6px;display:flex;align-items:center;justify-content:center;box-shadow:0 0 5px rgba(0,0,0,.4);">
            <svg xmlns='http://www.w3.org/2000/svg' width='26' height='26' viewBox='0 0 33 32' fill='none'>
              <path d='M6.75 16.034L15.7045 7.07951C16.1438 6.64017 16.8562 6.64016 17.2955 7.0795L26.25 16.034M9 13.784V23.909C9 24.5303 9.50368 25.034 10.125 25.034H14.25V20.159C14.25 19.5377 14.7537 19.034 15.375 19.034H17.625C18.2463 19.034 18.75 19.5377 18.75 20.159V25.034H22.875C23.4963 25.034 24 24.5303 24 23.909V13.784M12.75 25.034H21' stroke='#23C5F6' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/>
            </svg>
          </div>
        `;

        const mainMarker = new AdvancedMarkerElement({
            map, position: {lat, lng}, content: homeIcon, title: this.property.address, gmpClickable: true,
            zIndex: 1000,
        });

        mainMarker.addEventListener("gmp-click", () => {
            infoWindow.close();
            infoWindow.setContent(subjectCardHTML());
            infoWindow.open(map, mainMarker);
        });

        this.comps.forEach((c) => {
            const color = c.rule_color || '#F7FBFD';
            const isActive = c.status === 'active';
            const isOutside = c.status === 'outside';
            const borderStyle = isActive ? '2px solid #22c55e' : isOutside ? '1px solid #97B0BF' : '1px solid transparent';
            const zIndex = isActive ? 900 : 800;

            const pin = document.createElement("div");
            pin.innerHTML = `
                  <div style="background:rgba(0,0,0,.75);border-radius:50%;padding:4px;display:flex;align-items:center;justify-content:center;box-shadow:0 0 5px rgba(0,0,0,.4);border:${borderStyle};">
                    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none'>
                      <path d='M15 10.5c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3Z' stroke='${color}' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/>
                      <path d='M19.5 10.5C19.5 17.6421 12 21.75 12 21.75S4.5 17.6421 4.5 10.5C4.5 6.3579 7.8579 3 12 3s7.5 3.3579 7.5 7.5Z' stroke='${color}' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/>
                    </svg>
                  </div>`;

            const marker = new AdvancedMarkerElement({
                map,
                position: {lat: parseFloat(c.latitude), lng: parseFloat(c.longitude)},
                content: pin,
                title: c.address || c.title || "Comparable",
                gmpClickable: true,
                zIndex,
            });


            marker.addEventListener("gmp-click", () => {
                infoWindow.close();
                infoWindow.setContent(compCardHTML(c));
                infoWindow.open(map, marker);
            });
        });
    },
    startPolygon(map, lat, lng, { Polygon, event, LatLng }, vertices = []) {
        // --- Start Polygon Editing Logic ---
        const MAX_VERTICES = 10;
        const MAX_DISTANCE_MILES = 2;
        const anchorPoint = { lat, lng };

        const polygonCoords = vertices.length >= 4 && vertices.length <= 10
            ? vertices
            : this.generateRadiusVertices(lat, lng, 1.5, 6);
        let editablePolygon = null;
        let isDragging = false;
        let lastValidPath = [];

        if (polygonCoords && polygonCoords.length > 2) {

            lastValidPath = polygonCoords.map(c => ({ lat: c.lat, lng: c.lng }));

            editablePolygon = new Polygon({
                paths: polygonCoords,
                editable: this.editable,
                draggable: this.editable,
                strokeColor: "#23C5F6",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#23C5F6",
                fillOpacity: 0.18,
                map: map,
            });

            const path = editablePolygon.getPath();

            const captureVertices = () => {
                const verts = [];
                for (let i = 0; i < path.getLength(); i++) {
                    verts.push({ lat: path.getAt(i).lat(), lng: path.getAt(i).lng() });
                }

                lastValidPath = JSON.parse(JSON.stringify(verts));

                if (this.editable) {
                    this.$dispatch('map::vertices::updated', {
                        vertices: verts,
                    });
                }
            };

            event.addListener(editablePolygon.getPath(), 'insert_at', (index) => {
                const newPoint = path.getAt(index);
                const currentPathArray = path.getArray().map(p => ({ lat: p.lat(), lng: p.lng() }));

                if (path.getLength() > MAX_VERTICES) {
                    this.removeVerticeAndToasMessage(path, index, `Limit of ${MAX_VERTICES} vertices reached. Additional points cannot be added.`);
                    return;
                }

                if (!this.isInsidePolygon(anchorPoint.lat, anchorPoint.lng, currentPathArray)) {
                    this.removeVerticeAndToasMessage(path, index, `Vertex cannot be outside the polygon.`);
                    return;
                }

                const distance = this.getDistanceInMiles(anchorPoint.lat, anchorPoint.lng, newPoint.lat(), newPoint.lng());

                if (distance > MAX_DISTANCE_MILES) {
                    this.removeVerticeAndToasMessage(path, index, `Vertex cannot exceed ${MAX_DISTANCE_MILES} miles from the center.`);
                    return;
                }

                captureVertices();
            });

            event.addListener(editablePolygon.getPath(), 'remove_at', () => {
                captureVertices();
            });

            event.addListener(editablePolygon, 'dragstart', () => {
                isDragging = true;
            });

            event.addListener(editablePolygon, 'dragend', () => {
                const currentPathArray = path.getArray().map(p => ({ lat: p.lat(), lng: p.lng() }));

                if (!this.isInsidePolygon(anchorPoint.lat, anchorPoint.lng, currentPathArray)) {
                    this.resetToLastValidVertices(path, lastValidPath);

                    this.$dispatch('toast::show', { type: 'error', message: `Vertex cannot be outside the polygon.` });
                    isDragging = false;
                    return;
                }

                let passes = true;
                for (let i = 0; i < currentPathArray.length; i++) {
                    const newPoint = path.getAt(i);

                    const distance = this.getDistanceInMiles(anchorPoint.lat, anchorPoint.lng, newPoint.lat(), newPoint.lng());

                    if (distance > MAX_DISTANCE_MILES) {
                        passes = false;

                        break;
                    }
                }

                if (!passes) {
                    this.resetToLastValidVertices(path, lastValidPath);

                    this.$dispatch('toast::show', { type: 'error', message: `Vertex cannot exceed ${MAX_DISTANCE_MILES} miles from the center.` });

                    isDragging = false;

                    return;
                }

                captureVertices();
                isDragging = false;
            });

            event.addListener(editablePolygon.getPath(), 'set_at', (index) => {
                if (isDragging) {
                    return;
                }

                const newPoint = path.getAt(index);
                const currentPathArray = path.getArray().map(p => ({ lat: p.lat(), lng: p.lng() }));

                if (!this.isInsidePolygon(anchorPoint.lat, anchorPoint.lng, currentPathArray)) {
                    path.setAt(index, new LatLng(lastValidPath[index].lat, lastValidPath[index].lng));

                    return
                }

                const distance = this.getDistanceInMiles(anchorPoint.lat, anchorPoint.lng, newPoint.lat(), newPoint.lng());

                if (distance > MAX_DISTANCE_MILES) {
                    path.setAt(index, new LatLng(lastValidPath[index].lat, lastValidPath[index].lng));
                    this.$dispatch('toast::show', { type: 'error', message: `Vertex cannot exceed ${MAX_DISTANCE_MILES} miles from the center.` });
                    return;
                }

                captureVertices();
            });

            captureVertices();
        }

        // --- End Polygon Editing Logic ---
    },
    generateRadiusVertices(centerLat, centerLng, miles, numVertices) {
        const coords = [];
        const kmPerMile = 1.60934;
        const radiusInKm = miles * kmPerMile;
        const earthRadiusKm = 6371; // Earth's radius in KM

        // Convert lat/lng to radians
        const latRad = (centerLat * Math.PI) / 180;
        const lngRad = (centerLng * Math.PI) / 180;

        for (let i = 0; i < numVertices; i++) {
            // Calculate the bearing (0, 36, 72... degrees) in radians
            const bearing = (i * 360 / numVertices) * Math.PI / 180;

            // Spherical Law of Cosines to find new Lat
            const newLatRad = Math.asin(
                Math.sin(latRad) * Math.cos(radiusInKm / earthRadiusKm) +
                Math.cos(latRad) * Math.sin(radiusInKm / earthRadiusKm) * Math.cos(bearing)
            );

            // Find new Lng
            const newLngRad = lngRad + Math.atan2(
                Math.sin(bearing) * Math.sin(radiusInKm / earthRadiusKm) * Math.cos(latRad),
                Math.cos(radiusInKm / earthRadiusKm) - Math.sin(latRad) * Math.sin(newLatRad)
            );

            coords.push({
                lat: (newLatRad * 180) / Math.PI,
                lng: (newLngRad * 180) / Math.PI
            });
        }
        return coords;
    },
    isInsidePolygon(pointLat, pointLng, polygon) {
        let isInside = false;
        for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
            const iLat = polygon[i].lat;
            const iLng = polygon[i].lng;
            const jLat = polygon[j].lat;
            const jLng = polygon[j].lng;

            const intersect = ((iLat > pointLat) !== (jLat > pointLat)) &&
                (pointLng < (jLng - iLng) * (pointLat - iLat) / (jLat - iLat) + iLng);

            if (intersect) isInside = !isInside;
        }
        return isInside;
    },
    getDistanceInMiles(lat1, lon1, lat2, lon2) {
        const R = 3958.8; // Earth's radius in miles
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLon = (lon2 - lon1) * Math.PI / 180;
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    },
    removeVerticeAndToasMessage(path, index, message) {
        setTimeout(() => {
            path.removeAt(index);

            this.$dispatch('toast::show', {
                type: 'error',
                message: message
            });
        }, 0);
    },
    resetToLastValidVertices(path, lastValidPath) {
        for (let i = 0; i < lastValidPath.length; i++) {
            path.setAt(i, new this._LatLng(lastValidPath[i].lat, lastValidPath[i].lng));
        }
    }
});

function formatIntegerToCurrency(value, withoutDollarSign = false) {
    if (value == null || isNaN(value)) return "-";
    const formatted = (value / 100).toLocaleString("en-US", {
        style: "currency", currency: "USD", minimumFractionDigits: 2,
    });
    return withoutDollarSign ? formatted.replace("$", "") : formatted;
}
